import { gql } from '@apollo/client';

export const GET_CHECKHOMEWORKS_EXCEL = gql`
  query SkWeb_CheckHomeworksExcel($assignmentId: ID!) {
    checkHomeworksExcel(assignmentId: $assignmentId) {
      schoolName
      classroomName
      assignerUsername
      assignerName
      homeworks {
        progress
        doneDate
        username
        name
        hwGrade
        makeUpGrade
      }
      assignedDate
      startDate
      dueDate
      title
      bookset
      book
      units
      styleCount
    }
  }
`;
